import {useEffect, useState} from 'react';

export type PhoneCode = {
  name: string;
  flag: string;
  code: string;
  dial_code: string;
};

let phoneCodeCache: PhoneCode[] | null = null;
let loadPromise: Promise<PhoneCode[]> | null = null;

const loadPhoneCodeData = async (): Promise<PhoneCode[]> => {
  if (phoneCodeCache) return phoneCodeCache;
  if (!loadPromise) {
    loadPromise = import('../data/phone-codes.json').then((module) => {
      phoneCodeCache = module.default as PhoneCode[];
      return phoneCodeCache;
    });
  }
  return loadPromise;
};

export const getPhoneCodes = loadPhoneCodeData;

export const usePhoneCodes = () => {
  const [codes, setCodes] = useState<PhoneCode[]>(phoneCodeCache || []);

  useEffect(() => {
    let isMounted = true;
    if (!phoneCodeCache) {
      loadPhoneCodeData().then((data) => {
        if (isMounted) setCodes(data);
      });
    }
    return () => {
      isMounted = false;
    };
  }, []);

  return codes;
};
